// Simple base64 encoding utility for localStorage
// Provides basic obfuscation without complex encryption

// Encode data - simple base64 encoding
function encode(data: string): string {
  try {
    return btoa(encodeURIComponent(data));
  } catch (error) {
    return data;
  }
}

// Decode data - simple base64 decoding
function decode(encodedData: string): string {
  try {
    return decodeURIComponent(atob(encodedData));
  } catch (error) {
    return '';
  }
}

// Secure storage wrapper for localStorage
export const secureStorage = {
  setItem(key: string, value: string): void {
    const encoded = encode(value);
    localStorage.setItem(key, encoded);
  },

  getItem(key: string): string | null {
    const encoded = localStorage.getItem(key);
    if (!encoded) return null;

    const decoded = decode(encoded);
    return decoded || null;
  },

  removeItem(key: string): void {
    localStorage.removeItem(key);
  },

  clear(): void {
    localStorage.clear();
  },
};
